import { deleteAssets } from '../actions';
import { deleteClientSideAssets } from '../privateActions';
import { deleteOutlookSpaceAsset } from '../service';
import { deleteAssetFailed } from './deleteAssetsOrchestrator.locstring.json';
import { orchestrator } from 'satcheljs';
import type { AssetId, ProjectId } from 'owa-timestream-types';
import loc from 'owa-localize';
import resolveAssetId from '../assetId/resolveAssetId';
import showRetryNotification from '../utils/showRetryNotification';

orchestrator(deleteAssets, ({ projectId, assetIds }) => {
    deleteClientSideAssets(projectId, assetIds);
    assetIds.forEach(assetId => deleteAssetWithErrorNotification(projectId, assetId));
});

async function deleteAssetWithErrorNotification(projectId: ProjectId, assetId: AssetId) {
    try {
        const outlookSpaceAssetId = await resolveAssetId(assetId);
        if (outlookSpaceAssetId) {
            await deleteOutlookSpaceAsset(projectId, outlookSpaceAssetId);
        }
    } catch {
        // $TODO: report errors? If so, do not report Not Found errors.

        // Note that we aren't going to recreate the local asset if the delete fails, although we'll
        // still allow a retry button on failure.
        showRetryNotification('deleteAssets', loc(deleteAssetFailed), () => {
            deleteAssetWithErrorNotification(projectId, assetId);
        });
    }
}
